import { useQueryTravelDetails } from '../../models'

export interface UseTravelDetailsPresenterParams {
  uuid: string
}

/**
 * Companion hook — also consumed hook-data-only by the `TravelDetailsView`
 * Feature Set (action gating) and by `TravelEditView` (2.5). React Query
 * dedupes via the shared `travelQueryConfig.detail(uuid)` key (ADR-2).
 */
export const useTravelDetailsPresenter = ({
  uuid,
}: UseTravelDetailsPresenterParams) => {
  const { travel, isLoading, error } = useQueryTravelDetails({ uuid })

  return {
    data: {
      travel,
    },
    states: {
      isLoading,
      error,
    },
  }
}
